import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { UserService } from "../../../../../shared";
import { DataService_ReminderAlertSetup } from "../../shared/data.service";
import { StationReminderAlertInsertRequest } from "../../shared/StationReminderAlertInsertRequest";
import * as moment from "moment";

@Component({
	selector: "app-scan-reminder-add",
	templateUrl: "./scan-reminder-add.component.html",
	styleUrls: ["./scan-reminder-add.component.css"],
})
export class ScanReminderAddComponent implements OnInit {
	constructor(
		private userService: UserService,
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private reminderService: DataService_ReminderAlertSetup
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();
		this.UserLevelID = this.user.UserLevelID;

		this.SchoolID = this.dialogConfig.data.SchoolID;

		this.loadSound();
	}

	/////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////

	user: any;
	UserLevelID: number = 3;

	SchoolID: number = -1;

	selectedGroupValue: number = 2; //1 All Schools, 2 Selected School

	Messagecolor: any = "#000000";
	Message: string = "";

	SelectedSound: any;
	lstSoundItems: any = [];

	SelectedAlertTypeID: number = 1;
	lstAlertType: any = [
		{
			ID: 1,
			Desc: "Play Once",
		},
		{
			ID: 2,
			Desc: "Play Until Removed",
		},
		{
			ID: 3,
			Desc: "Play in Date Range",
		},
	];

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	Priority: number = 2;
	lstPriority: any = [
		{
			ID: 1,
			Desc: "High",
		},
		{
			ID: 2,
			Desc: "Medium",
		},
		{
			ID: 3,
			Desc: "Low",
		},
	];

	EntryMode: boolean = true;
	ExitMode: boolean = true;
	MealMode: boolean = true;
	AccessMode: boolean = true;
	TimeStampMode: boolean = true;
	EventEntryMode: boolean = true;
	EventExitMode: boolean = true;

	ParentPortalSendNotification: boolean = false;
	StudentPortalSendNotification: boolean = false;
	StaffPortalSendNotification: boolean = false;

	loading: boolean = false;
	Processing: boolean = false;

	audio: any = new Audio();

	errorMessage: string = "";

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////

	loadSound() {
		this.loading = true;

		//
		// Load school sounds or district-only sounds?
		// School-Only sounds might break for district-level alert
		//
		var result = this.reminderService.LoadSoundPopupList(this.selectedGroupValue == 2 ? this.SchoolID : -1);
		result.subscribe(
			(response) => {
				this.lstSoundItems = response;

				this.lstSoundItems.unshift({
					SoundLibraryID: -1,
					SoundFile: "None",
					SoundData: null,
				});

				this.SelectedSound = this.lstSoundItems[0];

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		//
		// Error Handling
		//

		var fsDate: string = "";
		var feDate: string = "";

		if (this.SelectedAlertTypeID == 3) {
			fsDate = moment(this.StartDate).format("MM/DD/YYYY");
			feDate = moment(this.EndDate).format("MM/DD/YYYY");

			if (String(fsDate).toLowerCase().indexOf("invalid") != -1) {
				this.errorMessage = "Invalid Start Date";
				return;
			}
			if (String(feDate).toLowerCase().indexOf("invalid") != -1) {
				this.errorMessage = "Invalid End Date";
				return;
			}
		}

		// var lstPIDs: number[] = [];

		//
		// Create Parms
		//

		this.Processing = true;

		var parms: StationReminderAlertInsertRequest = {
			SchoolID: this.selectedGroupValue == 2 ? this.SchoolID : -1,
			Message: this.Message,
			AlertType: this.SelectedAlertTypeID,
			MessageFontColor: this.Messagecolor,
			SoundLibraryID: this.SelectedSound.SoundLibraryID,
			StartDate: fsDate,
			EndDate: feDate,
			// lstPersonIDs: lstPIDs

			Priority: this.Priority,
			EntryMode: this.EntryMode == true ? 1 : 0,
			ExitMode: this.ExitMode == true ? 1 : 0,
			MealMode: this.MealMode == true ? 1 : 0,
			AccessMode: this.AccessMode == true ? 1 : 0,
			TimeStampMode: this.TimeStampMode == true ? 1 : 0,
			EventEntryMode: this.EventEntryMode == true ? 1 : 0,
			EventExitMode: this.EventExitMode == true ? 1 : 0,

			ParentPortalSendNotification: this.ParentPortalSendNotification == true ? 1 : 0,
			StudentPortalSendNotification: this.StudentPortalSendNotification == true ? 1 : 0,
			StaffPortalSendNotification: this.StaffPortalSendNotification == true ? 1 : 0,
		};

		var result = this.reminderService.StationReminderAlertInsert(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Status == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Reminder Added Successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not create the Reminder",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	onPlay() {
		this.errorMessage = "";

		if (this.SelectedSound == null || this.SelectedSound.SoundData == null) {
			this.errorMessage = "Select a sound to play";
			return;
		}

		this.audio.src = this.SelectedSound.SoundData;
		this.audio.load();
		this.audio.play();
	}

	onStop() {
		this.errorMessage = "";

		if (this.audio.src != null && this.audio.currentTime > 0) {
			this.audio.pause();
			this.audio.currentTime = 0;
		}
	}
	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	//Events
	/////////////////////////////////////////////////////////////////////
	onSoundChange(val) {
		this.SelectedSound = val;

		this.onStop();
	}

	onSelectedGroupValueChange(val) {
		this.selectedGroupValue = val;

		this.loadSound();
	}
	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////
	IsLoading() {
		return this.loading == true || this.Processing == true;
	}
	/////////////////////////////////////////////////////////////////////
}
